import { useEffect, useRef } from 'react';
import { useDialogContext } from 'src/contexts/DialogContext';

const useRemoveScrollbar = (open: boolean): void => {
  const { incrementDialog, decrementDialog, dialogCount } = useDialogContext();
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    if (open) {
      incrementDialog();
    } else {
      decrementDialog();
    }
  }, [open, incrementDialog, decrementDialog]);

  useEffect(() => {
    const body = document.querySelector('body');
    if (dialogCount > 0) {
      body?.classList.add('overflow-hidden');
    } else {
      body?.classList.remove('overflow-hidden');
    }
  }, [dialogCount]);
};

export default useRemoveScrollbar;
